import { InfoIcon } from "lucide-react";
import { observer } from "mobx-react-lite";

import { usePlaygroundDialogStore } from "../playground-dialog-store";
import { PlaygroundDialogType } from "../constants";

import {
  Dialog,
  DialogTitle,
  DialogHeader,
  DialogFooter,
  DialogContent,
} from "@/components/ui/dialog";
import { useUser } from "@/context/user-context";
import { Button } from "@/components/ui/button";

const savePromptReasons = [
  "Never lose that one good prompt!",
  "Compare prompt versions side-by-side.",
  "Rollback to the last version if your changes don’t work out.",
  "Test prompt updates and see improvements over time.",
];

export const PromptToSaveVersion = observer(
  ({ handleButtonClick }: { handleButtonClick: () => void }) => {
    const store = usePlaygroundDialogStore();
    const { user } = useUser();

    const title = user?.name
      ? `${user.name}, do you want to save this version?`
      : "Do you want to save this version?";

    const handleClose = () => {
      handleButtonClick();
      store.onClose?.();
    };

    return (
      <Dialog
        open={store.isDialogOpen}
        onOpenChange={value =>
          store.setIsDialogOpen({
            isOpen: value,
            dialogType: PlaygroundDialogType.PromptToSaveVersion,
          })
        }
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-1">
            <span className="text-sm text-gray-500">
              Don't lose your progress. PromptLayer can help you keep track of all your prompt
              edits.
            </span>
            <div>
              <ul className="mt-3 list-none space-y-2.5 text-sm">
                {savePromptReasons.map((reasonItem, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={`reason-${index}`} className="flex items-center pl-1.5">
                    <span className="mr-2.5 inline-flex items-center justify-center text-blue-500">
                      <InfoIcon className="h-4 w-4" />
                    </span>
                    <span className="text-gray-700">{reasonItem}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <DialogFooter>
            <div className="flex w-full items-center justify-end gap-2">
              <Button onClick={handleClose}>Save Prompt</Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  },
);
